<script setup lang="ts">
/**
 * AURA Chat - Main chat view component
 * Main chat interface integrating all sub-components
 */
import { computed, ref, onMounted, watch } from 'vue';
import AuraComposer from '@/views/pages/aura/components/AuraComposer.vue';
import { useAuraStore, useFilterStore } from '@/stores';

const isLoading = ref(true);
const auraStore = useAuraStore();
const filterStore = useFilterStore();
const levelId = computed(() => filterStore.level?.id ?? null);

watch(
    levelId,
    () => {
        auraStore.reset(true);
    },
    { immediate: true },
);

onMounted(async () => {
    // Composer loads the real AURA context from the backend.
    isLoading.value = false;
});
</script>

<template>
    <div class="aura-chat h-[calc(100dvh-64px)] min-h-0 w-full">
        <!-- Main chat interface - integrated with portal sidebar/header -->
        <AuraComposer :key="levelId ?? 'no-level'" :is-loading="isLoading" />
    </div>
</template>
